import { groupThousands } from '../../../shared/utils/currency';

/** Format a number with 2 decimals and space thousand separators, no currency symbol. */
export const formatNumericValue = (n: number): string => groupThousands(n.toFixed(2));

/** Derive avatar initials from the user's email (preferred) or phone. */
export const getInitials = (email: string, phone: string): string => {
  const source = email || phone;
  if (!source) {
    return '?';
  }
  // Email: take first letter + first letter after @
  if (email && email.includes('@')) {
    const [local, domain] = email.split('@');
    return (local[0] + (domain[0] ?? '')).toUpperCase();
  }
  // Phone: take last two digits
  const digits = source.replace(/\D/g, '');
  return digits.slice(-2) || source.slice(0, 2).toUpperCase();
};
